import React, { useState } from "react";
import axios from "axios";
import { AppBar, Layout } from "react-admin";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { Select, MenuItem, FormControl } from "@material-ui/core";
import { Admin } from "react-admin";
//import { LocalesMenuButton } from "react-admin";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LicenseInfo } from "@mui/x-license-pro";

import customRoutes from "./customRoutes";
import { msalConfig } from "./lib/authConfig";
import Menu from "./Menu";
// Providers
import dataProvider from "./lib/dataProvider";
import authProvider from "./lib/authProvider";
// Login
// import LoginPage from "./components/login/LoginPage";
import LoginPage from "./components/auth/LoginPage";
import { ClientConfigProvider } from "./context/clientConfigContext";

// Default logo
const DEFAULT_LOGO = "https://cystellar-logo.s3-eu-west-1.amazonaws.com/cystellar-logo.png";
const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
const baseUrl = process.env.REACT_APP_BASE_URL;
const authUrl = process.env.REACT_APP_AUTH_URL;
const faviconUrl = `${process.env.PUBLIC_URL}images/companies/${ENVIRONMENT}.png`;

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_X_LICENSE_KEY);

const capitalize = (s) => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};
// axios instance used for launchpad only
const httpClient = (baseURL) => {
  const user = JSON.parse(localStorage.getItem("user"));

  const instance = axios.create({
    baseURL,
    headers: {
      Authorization: user && user.accessToken && `Bearer ${user.accessToken}`,
      "x-client-name-launchpad": process.env.REACT_APP_ENVIRONMENT,
    },
  });
  return instance;
};

const useStyles = makeStyles({
  title: {
    flex: 1,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    marginLeft: -10,
  },
  spacer: {
    flex: 1,
  },
  logo: {
    maxWidth: "40px",
    marginLeft: -35,
  },
});

const BrandAppBar = (props) => {
  const [language, setLanguage] = useState(localStorage.getItem("language"));
  const classes = useStyles();
  const location = useLocation();
  const { t } = useTranslation();

  const user = JSON.parse(localStorage.getItem("user"));

  const companyLogo = user && user.companyLogo ? user.companyLogo : DEFAULT_LOGO;

  const headerMap = {
    "/climateAnalytics": t("climateAnalytics.title"),
    "/newpolicies/": t("policy.headerTitle"),
    "/policiesagriculture/": t("policy.headerTitle"),
    "/newpolicies": t("menu.policiesHeaderTitles"),
    "/newclaims/": t("claims.headerTitle"),
    "/claimsagriculture/": t("claims.headerTitle"),
    "/newclaims": t("menu.claimsHeaderTitles"),
    "/policiesagriculture": t("menu.agrPoliciesHeaderTitle"),
    "/claimsagriculture": t("menu.agrClaimsHeaderTitle"),
    "/riskassessment": t("menu.riskAssessment"),
  };

  const handleChange = (event) => {
    setLanguage(event.target.value);
    localStorage.setItem("language", event.target.value);
    window.location.reload();
  };

  window.addEventListener("error", (e) => {
    if (
      e.message === "ResizeObserver loop limit exceeded" ||
      e.message === "ResizeObserver loop completed with undelivered notifications."
    ) {
      const resizeObserverErrDiv = document.getElementById("webpack-dev-server-client-overlay-div");
      const resizeObserverErr = document.getElementById("webpack-dev-server-client-overlay");
      if (resizeObserverErr) {
        resizeObserverErr.setAttribute("style", "display: none");
      }
      if (resizeObserverErrDiv) {
        resizeObserverErrDiv.setAttribute("style", "display: none");
      }
    }
  });

  const pathnameTitle = Object.keys(headerMap).find((key) => location.pathname.includes(key));
  const headerTitle = headerMap[pathnameTitle];

  return (
    <AppBar {...props}>
      <img style={{ width: 70 }} src={companyLogo} alt="Reale Mutua Logo" />
      <Typography variant="h6" color="inherit" className={classes.title} id="react-admin-title" />
      <Typography variant="h6" color="inherit" className={classes.title} id="react-admin-title">
        {headerTitle}
      </Typography>
      <FormControl variant="outlined" size="small">
        <Select labelId="label" id="select" value={language} onChange={handleChange}>
          <MenuItem value="en">
            <span className="fi fi-gb"></span>
          </MenuItem>
          <MenuItem value="it">
            <span className="fi fi-it"></span>
          </MenuItem>
        </Select>
      </FormControl>
    </AppBar>
  );
};

const BrandLayout = (props) => <Layout {...props} appBar={BrandAppBar} />;

const msalInstance = new PublicClientApplication(msalConfig);

const App = () => {
  const favicon = document.getElementById("favicon");
  document.title = `${capitalize(ENVIRONMENT)} - Geospatial Intelligence`;
  favicon.href = faviconUrl;

  return (
    <ClientConfigProvider>
      <MsalProvider instance={msalInstance}>
        <Admin
          layout={BrandLayout}
          loginPage={LoginPage}
          dataProvider={dataProvider(baseUrl, httpClient)}
          authProvider={authProvider(authUrl, httpClient)}
          customRoutes={customRoutes}
          menu={Menu}
        >
          <></>
        </Admin>
      </MsalProvider>
    </ClientConfigProvider>
  );
};

export default App;
